<script setup lang="ts">
import type { THEME } from '@pkg/config/misc/theme';
import { BaseTicker, type TickerProps } from '../../inner/Ticker';

type Props = Omit<TickerProps, 'size'> & {
  theme: THEME;
};

const props = withDefaults(defineProps<Props>(), {
  reversed: false,
  logos: undefined,
  tickerType: undefined,
});
</script>

<template>
  <section class="c-outer-ticker" :data-theme="theme">
    <BaseTicker v-bind="props" size="small" />
  </section>
</template>

<style scoped>
.c-outer-ticker {
  background-color: var(--theme-background-color);
  padding: theme('padding.8') 0;
  overflow: hidden;

  @screen tablet-wide {
    padding: theme('padding.12') 0;
  }
}
</style>
